import React from 'react'

import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'
import Card from '@material-ui/core/Card'

import Widget from '../../Widget'

import IconPicker from '../../../../apps/AppComponents/IconPicker/IconPicker'
import { logDashboardEvent } from '../../../events'

function ApplyTab({ widgetData, widgetId, classes, dispatch }) {
  const handleIconClick = (link) => {
    if (widgetId && dispatch) {
      logDashboardEvent(
        dispatch,
        'dashboardEvent',
        widgetId,
        link.title,
        link.url,
      )
    }
    window.open(link.url, '_blank')
  }

  const handleNeedAssistanceClick = () => {
    if (widgetId && dispatch) {
      logDashboardEvent(
        dispatch,
        'dashboardEvent',
        widgetId,
        'Need Assistance',
        'https://financialaid.rutgers.edu/contact/',
      )
    }
    window.open('https://financialaid.rutgers.edu/contact/', '_blank')
  }

  return (
    <Grid container display="flex" direction="row" className={classes.viewGrid}>
      <Grid item xs={12}>
        <Card className={classes.schoolCodeCard} variant="outlined">
          <Typography variant="body1">
            Rutgers Federal School Code: 002629
          </Typography>
        </Card>
      </Grid>
      <Grid
        item
        container
        direction="row"
        alignItems="stretch"
        justifyContent="center"
        className={classes.buttonGrid}
      >
        {widgetData.applyTab.links.map((link) => (
          <Grid
            item
            key={link.title}
            xs={4}
            className={classes.buttonGridItem}
            onClick={() => handleIconClick(link)}
          >
            <Widget.TabLink
              icon={<IconPicker iconName={link.icon} size="3x" color="gray" />}
              iconLabel={link.title}
              hyperLink={link}
              widgetId={widgetId}
              dispatch={dispatch}
            />
          </Grid>
        ))}
      </Grid>
      <Grid item xs={12} className={classes.assistanceFooter}>
        <Card
          className={classes.assistanceCard}
          variant="outlined"
          onClick={handleNeedAssistanceClick}
        >
          <Grid container direction="row" justifyContent="center" spacing={1}>
            <Grid item>
              <IconPicker iconName="phone" size="1x" color="gray" />
            </Grid>
            <Grid item>
              <Typography variant="body1">Need Assistance?</Typography>
            </Grid>
          </Grid>
        </Card>
      </Grid>
    </Grid>
  )
}

export default ApplyTab
